




























































































































































































import Vue from 'vue';
import { Type, SwitchExpression, Expression, NoExpression, OperationPair, BooleanType, ChainExpression } from 'expangine-runtime';
import ExpressionBase from '../ExpressionBase';
import { getConfirmation } from '../../../app/Confirm';
import { ListOptions } from '../../../common';


export default ExpressionBase<SwitchExpression>().extend({
  name: 'SwitchEditor',
  data: () => ({
    sorting: false,
  }),
  computed: {
    valueType(): Type | null {
      return this.value.value.getType(this.registry.defs, this.context);
    },
    alternativeOperations(): ListOptions<string> {
      const empty = {};
      const { valueType, registry } = this;
      if (!valueType) {
        return [];
      }

      return registry.defs
        .getOperationsWithReturnType(BooleanType.baseType)
        .filter((pair) => this.registry.isValidOperation(pair))
        .filter(({ types, op }) => {
          const value = types.params.value 
            ? registry.defs.getOperationInputType(types.params.value, empty) 
            : null;
          const test = types.params.test 
            ? registry.defs.getOperationInputType(types.params.test, empty) 
            : null;

          return value && test && value.acceptsType(valueType) && test.acceptsType(valueType);
        })
        .map((pair) => {
          const value = pair.op.id;
          const { name: text, description } = registry.getOperationVisuals(value);

          return { text, description, value };
        })
      ;
    },
  },
  methods: {
    sortStart() {
      this.sorting = !this.sorting;
    },
    updateOperation(op: string) {
      this.value.op = op;
      this.update();
    },
    updateValue(value?: Expression) {
      this.value.value = value || NoExpression.instance;
      this.update();
    },
    updateTestValue(caseIndex: number, testIndex: number, testValue?: Expression) {
      if (!testValue) {
        this.value.cases[caseIndex][0].splice(testIndex, 1);
      } else {
        this.$set(this.value.cases[caseIndex][0], testIndex, testValue);
      }
      this.update();
    },
    addTestValue(caseIndex: number) {
      this.value.cases[caseIndex][0].push(NoExpression.instance);
      this.update();
    },
    updateBody(index: number, body?: Expression) {
      this.$set(this.value.cases[index], 1, body || NoExpression.instance);
      this.update();
    },
    addCase() {
      this.value.cases.push([[NoExpression.instance], NoExpression.instance]);
      this.update();
    },
    updateDefaultCase(otherwise?: Expression) {
      this.value.defaultCase = otherwise || NoExpression.instance;
      this.update();
    },
    isChain(expr: Expression) {
      return expr instanceof ChainExpression;
    },
    async removeCase(index: number) {
      if (await getConfirmation()) {
        this.value.cases.splice(index, 1);
        this.update();
      }
    },
  },
});
